module.exports = __webpack_public_path__ + "static/media/WordMark_eng_ai.12fa57d3.zip";